app.controller(
    'ItineraryTranslationController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'FlaneriesService', 'SideBarService', '$sce', '$translate', 'HelperService', '$window', ItineraryTranslationController]
);

function ItineraryTranslationController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, FlaneriesService, SideBarService, $sce, $translate, HelperService,$window) {
    var vm = this;
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    $translate.use($rootScope.LangForInterface);


    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;
    vm.DescriptionToTranslate = {};
    vm.SelectedDescriptionStatusItem = {};
    vm.PreviousDescriptionStatusItem = {};

    vm.ActiveDescriptionVm =
       {
           Clients: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
           QualificationList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }]
       };

    //if ($stateParams.lang2) {
    //    $rootScope.LangForTranslationDestination = $stateParams.lang2;
    //}
    //else {
    //    $rootScope.LangForTranslationDestination = '';
    //}
    vm.iti = {
        DescriptionPositionList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    };

    $scope.vm = {};
    $scope.edit = {};
    //strat    
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }    
    $translate.use($rootScope.LangForInterface);



    var FlaneriesGetSingle = FlaneriesService.getFlaneries($stateParams.id, $scope.CurrentLang, $rootScope.LangForTranslationDestination, $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    FlaneriesGetSingle.then(function (t) {
        vm.iti = t.data;
        vm.itiOrigin = angular.copy(vm.iti);

        if (vm.iti.DescriptionList.length > 0) {
            vm.ActiveDescriptionId = 0;
            vm.ActiveDescription = vm.iti.DescriptionList[vm.ActiveDescriptionId];

            //load descriptionVm
            vm.GetDescriptionVm();

            //load translation description
            vm.GetDescriptionTranslated();
        }

        $rootScope.Comments = vm.iti.CommentList;
        $rootScope.SideBar = vm.iti.SideBar;
        $rootScope.Clients = vm.iti.ClientList;
        $rootScope.ClassificationList = vm.iti.ClassificationList;
        $rootScope.SideBar.StatusList = vm.iti.StatusList;
        $rootScope.SideBar.CurrentObjectStatus = vm.iti.CurrentItineraryStatus;
        $rootScope.CurrentObjectId = $stateParams.id;
        $rootScope.CurrentPageType = $rootScope.EnumLinkType.Itinerary;
        $rootScope.PlaceList = vm.iti.PlaceList;
        //$scope.ChangeZoneById(vm.ParamZoneId);
    },
    function (e) {
        console.log('Chargement du lieu impossible', e);
    });

    //new methodes for iti desc
    vm.UpdateDescription = function () {
        if (vm.SelectedDescriptionStatusItem != undefined) {
            vm.DescriptionToTranslate.StatusId = vm.SelectedDescriptionStatusItem.id;
        }
        else {
            vm.DescriptionToTranslate.StatusId = 17;
        }
        if (vm.NewDescription) {
            HelperService.AddDescription(vm.DescriptionToTranslate)
            .then(function (data) {
                vm.NewDescription = !$rootScope.NewDescriptionTranslationIsAdded;
            });            
        }
        else {
            HelperService.UpdateDescription(vm.DescriptionToTranslate)
                .then(function (data) {

                });
        }
    }

    vm.UpdateDescriptionStatusId = function () {
        if (vm.SelectedDescriptionStatusItem != undefined) {
            vm.DescriptionToTranslate.StatusId = vm.SelectedDescriptionStatusItem.id;
        }
        else {
            vm.DescriptionToTranslate.StatusId = 17;
        }
        if (vm.NewDescription) {
            HelperService.AddDescription(vm.DescriptionToTranslate)
            .then(function (data) {
                vm.NewDescription = !$rootScope.NewDescriptionTranslationIsAdded;
            });            
        }
        else {
            if (vm.SelectedDescriptionStatusItem != vm.PreviousDescriptionStatusItem) {
                vm.PreviousDescriptionStatusItem = vm.SelectedDescriptionStatusItem;
                HelperService.UpdateDescription(vm.DescriptionToTranslate)
                    .then(function (data) {

                    });
            }
        }
    }

    vm.GetDescriptionTranslated = function () {
        HelperService.GetDescriptionById(vm.iti.DescriptionList[vm.ActiveDescriptionId].Description.DescriptionId, $rootScope.LangForTranslationDestination)
                                .then(function (desc) {
                                    if (desc.success == false) {
                                        vm.DescriptionToTranslate = angular.copy(vm.iti.DescriptionList[vm.ActiveDescriptionId].Description);
                                        vm.DescriptionToTranslate.LanguageCode = $rootScope.LangForTranslationDestination;
                                        vm.DescriptionToTranslate.IsDefaultLang = false;
                                        vm.DescriptionToTranslate.DescriptionTitle = '';
                                        vm.DescriptionToTranslate.Stick = '';
                                        vm.DescriptionToTranslate.Resume = '';
                                        vm.DescriptionToTranslate.Description = '';
                                        vm.DescriptionToTranslate.StatusTrad = $translate.instant("StatusId25");
                                        //init status
                                        vm.SelectedDescriptionStatusItem = $rootScope.StatusList4WorkflowDescriptionTranslationIdValue[0];
                                        vm.PreviousDescriptionStatusItem = angular.copy(vm.SelectedDescriptionStatusItem);
                                        vm.NewDescription = true;

                                    }
                                    else {
                                        vm.DescriptionToTranslate = desc;
                                        vm.SelectedDescriptionStatusItem = GetItemByFieldName(vm.DescriptionToTranslate.StatusId, 'id', $rootScope.StatusList4WorkflowDescriptionTranslationIdValue)[0];
                                        vm.PreviousDescriptionStatusItem = angular.copy(vm.SelectedDescriptionStatusItem);
                                        vm.NewDescription = false;
                                    }

                                });
    };


    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVm(vm.iti.DescriptionList[vm.ActiveDescriptionId].Description.DescriptionId, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
            });
    }

    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/traduction/walk?id=' + vm.iti.Iti.ItineraryId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }

    vm.PreviousDesc = function () {
        if (vm.iti.DescriptionList.length > 0 && vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            vm.GetDescriptionVm();
            vm.GetDescriptionTranslated();
        }
    }

    vm.NextDesc = function () {
        if (vm.iti.DescriptionList.length > 0 && vm.ActiveDescriptionId < vm.iti.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            vm.GetDescriptionVm();
            vm.GetDescriptionTranslated();
        }
    }

    //those methodes stay unchanged for now, itistep does not have multidesc

    $rootScope.TranslateDescription = function TranslateDescription(index) {
        FlaneriesService.TranslateDescription(vm.iti, $scope.CurrentLang, $rootScope.LangForTranslationDestination, index);
    };

    //$scope.UpdateItineraryTranslation = function UpdateItineraryTranslation() {
    //    FlaneriesService.UpdateItineraryTranslation(vm.iti);
    //};

    //$scope.UpdateDescriptionOld = function UpdateDescriptionOld() {
    //    FlaneriesService.UpdateDescription(vm.iti);
    //};

    //$scope.UpdateDescriptionStatus = function UpdateDescriptionStatus(status, index) {
    //    vm.iti.DescriptionList[index].Description.StatusId = status;
    //    FlaneriesService.UpdateDescriptionStatus(vm.iti,$rootScope.LangForTranslationDestination);
    //};


    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {
        SideBarService.UpdateObjectStatus(status, objectId, $rootScope.LangForTranslationDestination, 15);
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment($rootScope.vm.SideBar.CommentEdit, $stateParams.id, $rootScope.CurrentLang, 15);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {

        promiseAddComment = SideBarService.SaveDiffuseur($rootScope.vm.iti.ClientList, $stateParams.id, $rootScope.CurrentLang, 15);
    };

    $rootScope.SaveAdressesAssociees = function SaveAdressesAssociees() {

        promiseAddComment = SideBarService.SaveAdressesAssociees($rootScope.vm.iti.PlaceList, $stateParams.id, $rootScope.CurrentLang, 15);
    };

    $rootScope.SaveClassification = function SaveClassification() {

        promiseAddComment = SideBarService.SaveClassification($rootScope.vm.iti.ClassificationList, $stateParams.id, $rootScope.CurrentLang, 15);
    };



    $scope.dropdownDescIsOpen = false;

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.updateFieldTags = function () {
        $scope.$emit('updateFieldTags');
    };



    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Iti", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailShareItineraryPracticalInfo', $translate.instant('emailShareItineraryPracticalInfo').replaceAll('&amp;', '&'), $scope.vm);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }

};